import React from "react";
import Logo from "../assets/images/logo.webp";
import { Link } from "react-router-dom";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="footer overflow-hidden" >
      <div className="container" >
        <div className="row">
          <div className="col-lg-3  col-md-6">
            <div className="footer-margin">
              <div className="mb-4">
                <img className="logo-img" src={Logo} alt="SMS ZOO ZOO" />
              </div>
              <div>
                <ul className="list-unstyled footer-list mb-3">
                  <li>
                    <a href="https://www.instagram.com/smszoozoo" target="_blank" rel="noopener noreferrer"
                      className="social_media" aria-label="Visit our Instagram page">
                      <div className="">
                        <i class="fa-brands fa-instagram"></i>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/smszoozooads/" target="_blank" rel="noopener noreferrer"
                      className="social_media" aria-label="Visit our Facebook page">
                      <div className="">
                        <i class="fa-brands fa-facebook"></i>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/sms-zoo-zoo-ads" target="_blank" rel="noopener noreferrer"
                      className="social_media" aria-label="Visit our LinkedIn page">
                      <div className="">
                        <i class="fa-brands fa-linkedin-in"></i>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@smszoozoo" target="_blank" rel="noopener noreferrer"
                      className="social_media" aria-label="Visit our YouTube channel">
                      <div className="">
                        <i class="fa-brands fa-youtube"></i>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6"

          >
            <div className="footer-margin">
              <h5 className="footer-heading">Quick Link</h5>
              <ul className="list-footer-bottom">
                <li>
                  <Link to="/about_us" className=""
                    onClick={scrollToTop}>About Us
                  </Link>
                </li>
                <li> <Link to="/contact_us" className=""
                  onClick={scrollToTop}>Contact Us
                </Link></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6"

          >
            <div className="footer-margin">
              <h5 className="footer-heading">Contact</h5>
              <ul className="list-unstyled list-footer-bottom">
                <li>
                  <i class="fa-solid fa-envelope me-2"></i>
                  <a className="" href="mailto:info.smszoozoo@gmail.com">
                    info.smszoozoo@gmail.com
                  </a>
                </li>

                <li className="d-flex flex-start gap-2">
                  <div>
                    <i class="fa-solid fa-phone"></i>
                  </div>
                  <div>
                    <div>
                      <a href="tel:+919047745477">Sales - 9047745477</a>
                    </div>
                    <div>
                      <a href="tel:+918012917912">Support - 8012917912</a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6"

          >
            <div className="footer-margin">
              <h5 className="footer-heading">Address</h5>
              <ul className="list-unstyled list-footer-bottom">
                <li className="d-flex flex-start gap-2">
                  <div>
                    <i className="fa-solid fa-location-dot"></i>
                  </div>

                  <a
                    href="https://www.google.com/maps?q=13.0836,80.1900"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    152B, 2 Floor, Panner Nagar
                    <br className="br-tag" /> Main Road, Mogappair East,
                    <br className="br-tag" /> Chennai – 37.
                  </a>
                </li>

              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6"

          >
            <div className="footer-margin">
              <h5 className="footer-heading">WhatsApp Services</h5>
              <ul className="list-footer-bottom">
                <li> <Link to="/whatsapp_marketing" className=""
                  onClick={scrollToTop}>WhatsApp Marketing
                </Link></li>
                <li> <Link to="/click_to_whatsappads" className=""
                  onClick={scrollToTop}>Click to WhatsApp Ads
                </Link></li>
                <li> <Link to="/whatsapp_chatbots" className=""
                  onClick={scrollToTop}>WhatsApp Chatbots
                </Link></li>
                <li> <Link to="/whatsapp_business_api" className=""
                  onClick={scrollToTop}>WhatsApp Business API
                </Link></li>
                <li> <Link to="/whatsapp_bluetick" className=""
                  onClick={scrollToTop}>WhatsApp Blue Tick
                </Link></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6"

          >
            <div className="footer-margin">
              <h5 className="footer-heading">SMS Services</h5>
              <ul className="list-footer-bottom">
                <li> <Link to="/bulk_sms" className=""
                  onClick={scrollToTop}>Bulk SMS
                </Link></li>
                <li> <Link to="/rcs_messages" className=""
                  onClick={scrollToTop}>RCS SMS
                </Link></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6"

          >
            <div className="footer-margin">
              <h5 className="footer-heading">Social Media Marketing</h5>
              <ul className="list-footer-bottom">
                <li><Link to="/facebook_instagram_marketing" className=""
                  onClick={scrollToTop}>Facebook & Instagram
                </Link></li>
                <li><Link to="/linkedin_ads" className=""
                  onClick={scrollToTop}>LinkedIn
                </Link></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6"

          >
            <div className="footer-margin">
              <h5 className="footer-heading">Digital Marketing</h5>
              <ul className="list-footer-bottom">
                <li><Link to="/search_engine_optimization" className=""
                  onClick={scrollToTop}>SEO
                </Link></li>
                <li><Link to="/pay_per_click" className=""
                  onClick={scrollToTop}>PPC Campaign
                </Link></li>
                <li><Link to="/google_ads" className=""
                  onClick={scrollToTop}>Google Ads
                </Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row border-top py-4"

        >
          <div className="col-lg-6 col-md-6">
            <div className="flex-footer mb-lg-0 mb-md-0 mb-3">
              <Link to="/privacy_policy" onClick={scrollToTop} className="redirect-footer-links" >
                Privacy Policy
              </Link>
              {/* <Link to="/Terms_and_Condition"  onClick={scrollToTop} className="redirect-footer-links" >
                Terms & Conditions
              </Link> */}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 text-lg-end text-md-end text-center">
            <span className="fs-14">© sms zoo zoo. 2025 All rights reserved.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;